import {FilestackButton} from '../../../email-editor/filestack-button';
// @ts-expect-error - imported from .js/.jsx file
import {HtmlAttachmentIcon} from '../../../icon/svg/html-attachment-icon';
import {Stack} from '../../../layout/stack/stack';
import {Body} from '../../../typography/body';

import {IMAGE_UPLOAD_OPTIONS} from './consts';
import {SendButton} from './send-button';

interface Props {
    disabled: boolean;
    isSendDisabled: boolean;
    onSend: (input?: {snoozeDuration?: number; closeThread?: boolean} | null) => Promise<any>;
    isSending: boolean;
    showSnoozeOptions?: boolean;
    shouldEnforceCharacterLimit: boolean;
    isOverCharacterLimit: boolean;
    characterCount: number;
    characterLimit: number;
    charaterLimitRef: React.MutableRefObject<HTMLDivElement | null | undefined>;
    // @ts-expect-error
    onFilesUploaded: ({filesUploaded}) => void;
}

export function PlainTextInputFooter(props: Props) {
    return (
        <div className='flex justify-sb full-width gap-8'>
            <div className='flex align-center flex-shrink'>
                <FilestackButton
                    options={IMAGE_UPLOAD_OPTIONS}
                    buttonContent={
                        <Stack isHorizontal={true} spacing={8}>
                            <HtmlAttachmentIcon size={18} />
                            <Body size='small'>Upload</Body>
                        </Stack>
                    }
                    handleFilesUploaded={props.onFilesUploaded}
                    disabled={props.disabled}
                />
            </div>
            <div className='flex align-center gap-8 flex-shrink'>
                {props.shouldEnforceCharacterLimit && (
                    <Body
                        getBodyRef={props.charaterLimitRef}
                        color={props.isOverCharacterLimit ? 'error' : 'light'}
                        size='small'
                    >
                        {props.characterCount} / {props.characterLimit}
                    </Body>
                )}
                <SendButton
                    isDisabled={props.isSendDisabled}
                    onSend={props.onSend}
                    isSending={props.isSending}
                    showSnoozeOptions={props.showSnoozeOptions}
                />
            </div>
        </div>
    );
}
